module.exports = __webpack_public_path__ + "img/3-5.c81c6d64.png";